export default __webpack_public_path__ + "static/media/pgw.71298898.jpg";